import React from 'react';
import { SignUpContainer } from '../sign-up-container/sign-up-container';
import { ZoInputText } from '../zo-input-text-temp/zo-input-text-temp';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';

import './sign-up-now.scss';
import { useSignUpNow } from '@zonofi/gandalf-utilities';
import { isEmpty } from 'lodash';
import OtpInput from 'react-otp-input';
import { Button } from '@mui/material';
import { SellerDetails } from '@zonofi/zo-types';
import { useNavigate } from 'react-router-dom';
import { PNGS, SVGS } from '../assets';
import { SwipeableDrawer } from '../swipeable-drawer/swipeable-drawer';
import { CountriesList } from '../countries-list/countries-list';
import { digitCounts } from '@zonofi/i18n';

interface SignUpNowProps {
  isWorkspaceApiLoading: boolean;
  onUpdateValue: (key: string, value: string | boolean) => void;
  sellerDetails: SellerDetails;
  onOtpVerified: () => void;
}

export const SignUpNow: React.FC<SignUpNowProps> = ({
  isWorkspaceApiLoading,
  onUpdateValue,
  sellerDetails,
  onOtpVerified,
}) => {
  const navigator = useNavigate();
  const {
    loginVal,
    setLoginVal,
    otpToLogin,
    setOtpToLogin,
    isEmail,
    onGenerateOtp,
    sendOtpAPIResponse,
    setShowOtpInput,
    showOtpInput,
    onVerifyOtp,
    verifyOtpAPIResponse,
    timer,
    formatTime,
    resendEnabled,
    errorMessage,
    resendOTPInput,
    setErrorMessage,
    inputErrors,
    setInputErrors,
    validateInput,
    isLoginScreen,
    setIsLoginScreen,
    mobileInputRef,
    countryDrawerOpen,
    openCountriesDrawer,
    closeCountriesDrawer,
    selectedCountry,
    setSelectedCountry,
  } = useSignUpNow({ onOtpVerified, onUpdateValue, sellerDetails });
  const navigate = useNavigate();
  const signupContent = [
    {
      text: 'Grow basket size from existing customers',
      icon: PNGS.SignupIcon1,
      background: 'linear-gradient(112deg, #E6F0FF -36.69%, #FCFCFC 64.54%);',
      imageWidth: '34px',
      imageHeight: '34px',
      imageMargin: 0,
    },
    {
      text: 'Get Digital Leads from Facebook/ Insta',
      icon: PNGS.SignupIcon2,
      background: 'linear-gradient(112deg, #FFF7E6 -36.69%, #FCFCFC 64.54%)',
      imageWidth: '24px',
      imageHeight: '24px',
      imageMargin: 10,
    },
    {
      text: 'Reactivate dormant customers',
      icon: PNGS.SignupIcon3,
      background: 'linear-gradient(112deg, #F4ECFF -36.69%, #FCFCFC 64.54%)',
      imageWidth: '24px',
      imageHeight: '24px',
      imageMargin: 10,
    },
  ];

  return (
    <SignUpContainer
      setErrorMessage={() => {}}
      setInputErrors={() => {}}
      setShowOtpInput={() => {}}
      otpScreen={true}
      setIsLoginScreen={setIsLoginScreen}
    >
      <div className="sign-up-now">
        <div className="sign-up-now-heading">
          <span className="primary-font-semibold seller-font-size-heading heading">
            {isLoginScreen ? 'Login to ZöTok!' : 'Activate GenAI on WhatsApp'}
          </span>
          {!isLoginScreen && (
            <span className="primary-font-regular seller-font-size-medium sub-heading-with-icons">
              {signupContent.map((content, index) => (
                <span
                  key={index}
                  className="sub-heading-with-icons-item"
                  style={{ background: content.background }}
                >
                  {' '}
                  <img
                    style={{
                      width: content.imageWidth,
                      height: content.imageHeight,
                      marginRight: `${content.imageMargin / 2}px`,
                      marginLeft: `${content.imageMargin / 2}px`,
                      marginTop: `${content.imageMargin / 2}px`,
                      marginBottom: `${content.imageMargin / 2}px`,
                    }}
                    src={content.icon}
                    alt={content.text}
                  />{' '}
                  <span className="primary-font-regular sub-heading-with-icons-item-text">
                    {content.text}
                  </span>
                </span>
              ))}
            </span>
          )}
          {isLoginScreen && (
            <span className="primary-font-regular seller-font-size-medium sub-heading">
              {isLoginScreen
                ? 'You can do much more than just bulk messages on WhatsApp'
                : 'Just enter your email or phone number. Try it free for 15 days.'}
            </span>
          )}
        </div>
        <div className="sign-up-now-inputs">
          {!showOtpInput && (
            <>
              <div ref={mobileInputRef}>
                <ZoInputText
                  title={
                    isLoginScreen ? 'Mobile Number / Email Id' : 'Mobile Number'
                  }
                  name={'email'}
                  required={true}
                  startAdornment={
                    !isEmail ? (
                      <span
                        onClick={() =>
                          countryDrawerOpen
                            ? closeCountriesDrawer()
                            : openCountriesDrawer()
                        }
                        className="input-dial-code"
                      >
                        {`${selectedCountry?.dial_code} (${selectedCountry?.code})`}{' '}
                        <img
                          src={SVGS.SelectArrowDown}
                          alt=""
                          width={15}
                          height={15}
                        />
                      </span>
                    ) : null
                  }
                  value={loginVal}
                  onBlur={(val: string) => {}}
                  focusInput={!showOtpInput}
                  disabled={showOtpInput}
                  error={inputErrors?.isError}
                  helperText={inputErrors?.errorMsg}
                  helperTextProps={{
                    style: {
                      color: '#DD360C',
                    },
                  }}
                  showIcon={inputErrors?.isError}
                  inputFieldProps={{
                    name: 'loginVal',
                    value: loginVal,
                    style: {
                      letterSpacing: '1px',
                    },
                    onChange: (e: { target: { value: string } }) => {
                      let value;
                      if (!isEmail) {
                        value = e.target.value.replace(/\D/g, '');
                      } else {
                        value = e.target.value;
                      }
                      console.log(errorMessage, value, '23 errorMessage');
                      inputErrors?.isError && validateInput(value);
                      if (!isLoginScreen && isNaN(Number(value))) {
                        setErrorMessage('Please enter a valid mobile number');
                      } else if (isLoginScreen) {
                        setErrorMessage('');
                        setLoginVal(value);
                      } else if (!isLoginScreen && !isNaN(Number(value))) {
                        setErrorMessage('');
                        setLoginVal(value);
                      }
                    },
                    maxLength: !isEmail
                      ? digitCounts[selectedCountry?.code]
                      : undefined,
                  }}
                />
              </div>

              <SwipeableDrawer
                open={countryDrawerOpen}
                anchorRef={mobileInputRef}
                openDrawer={openCountriesDrawer}
                closeDrawer={closeCountriesDrawer}
              >
                <CountriesList
                  closeCountriesDrawer={closeCountriesDrawer}
                  selectedCountry={selectedCountry}
                  setSelectedCountry={(country) => {
                    onUpdateValue('dial_code', country?.dial_code);
                    setSelectedCountry(country);
                  }}
                  showCountryCode={true}
                />
              </SwipeableDrawer>
            </>
          )}
          {showOtpInput && (
            <div className="sign-up-now-inputs-change">
              <span className="sign-up-now-inputs-change-heading primary-font-regular">
                Mobile Number / Email Id<span>*</span>
              </span>
              <div className="sign-up-now-inputs-change-number">
                <span className="sign-up-now-inputs-change-number-text primary-font-regular">{`${
                  !isEmail ? selectedCountry?.dial_code : ''
                }${loginVal}`}</span>
                <Button
                  className="sign-up-now-inputs-change-number-button primary-font-regular"
                  variant="text"
                  onClick={() => {
                    setShowOtpInput(false);
                    setErrorMessage('');
                  }}
                >
                  <span className="primary-font-regular">Change</span>
                </Button>
              </div>
            </div>
          )}
          {!showOtpInput && (
            <>
              {errorMessage && (
                <span className="error-message font-12-regular-red">
                  {errorMessage}
                </span>
              )}
              <ZoButton
                onClick={onGenerateOtp}
                isLoading={sendOtpAPIResponse?.isLoading}
                label={'Continue'}
                style={{ border: '0px', fontFamily: 'Segoe-UI-SemiBold' }}
                className="sign-up-now-btn primary-font-semibold"
                disabled={
                  isEmail
                    ? isEmpty(loginVal)
                    : isEmpty(loginVal) && loginVal?.length !== 10
                }
              />
            </>
          )}
          {showOtpInput && (
            <>
              <div className="otp-input-container">
                <span style={{ color: errorMessage ? '#DD360C' : '#454545' }}>
                  {`Please enter 4 digit code sent to your ${
                    isEmail ? 'email id' : 'mobile number'
                  }`}
                </span>
                <OtpInput
                  value={otpToLogin}
                  onChange={setOtpToLogin}
                  numInputs={4}
                  inputType="number"
                  shouldAutoFocus={
                    sendOtpAPIResponse?.data?.mobile?.otp ||
                    sendOtpAPIResponse?.data?.email?.otp
                      ? false
                      : true
                  }
                  renderInput={(props) => <input {...props} />}
                  renderSeparator={<> </>}
                  containerStyle={{
                    width: '100%',
                    gap: 12,
                  }}
                  inputStyle={{
                    flex: 1,
                    height: 42,
                    borderRadius: 6,
                    border: '1px solid #bebebe',
                    fontSize: 16,
                    fontFamily: 'Segoe-UI-VF',
                    fontWeight: '600',
                  }}
                />
                {errorMessage && (
                  <span
                    className="input_text__helper-text font-12-regular-red"
                    style={{ color: '#DD360C' }}
                  >
                    <span className="input_text__helper-icon">
                      <img
                        style={{ transform: 'translateY(1px)' }}
                        // src={SHARED_SVGS.InputInfoError}
                        alt={'Error Icon'}
                      />
                    </span>

                    {errorMessage}
                  </span>
                )}
              </div>
              <div className="otp-resend-timer-wrapper">
                {timer > 0 ? (
                  <span className="otp-resend-timer-wrapper-text primary-font-regular seller-font-size-regular">
                    Resend OTP in: {formatTime(timer)}
                  </span>
                ) : (
                  <span
                    className="primary-font-regular seller-font-size-regular"
                    style={{ color: '#8c8c8c' }}
                  >
                    Resend OTP in 0:00
                  </span>
                )}
                <ZoButton
                  onClick={resendOTPInput}
                  disabled={!resendEnabled}
                  label={'Resend OTP'}
                  className="resend-otp-btn primary-font-semibold"
                  variant="secondary"
                />
              </div>
              {errorMessage && (
                <span className="error-message primary-font-semibold">
                  {showOtpInput && errorMessage}
                </span>
              )}
              <ZoButton
                onClick={onVerifyOtp}
                isLoading={
                  verifyOtpAPIResponse?.isLoading || isWorkspaceApiLoading
                }
                label={'Verify OTP'}
                className="sign-up-now-btn primary-font-semibold"
                disabled={
                  isEmpty(otpToLogin) || verifyOtpAPIResponse?.isLoading
                }
              />
            </>
          )}
          {showOtpInput &&
            sendOtpAPIResponse?.data?.message &&
            sendOtpAPIResponse?.data?.message !==
              'We already found an account with the Mobile/email' &&
            sendOtpAPIResponse?.data?.message !==
              `Sorry we couldn't find your details. please sign-up to experience zotok` && (
              <button
                type="button"
                className="login-container"
                onClick={() => navigator('/login')}
              >
                <span className="login-container-text">Login</span>
              </button>
            )}
        </div>

        {!isLoginScreen && (
          <span
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => {
              setShowOtpInput(false);
              setErrorMessage('');
              setInputErrors({
                isError: false,
                errorMsg: '',
              });
              navigate('/login');
              setIsLoginScreen(true);
            }}
            className="sign-up-container-terms seller-font-size-medium primary-font-semibold"
          >
            Already have an account?
            <a
              target="_blank"
              style={{
                textDecoration: 'underline',
                marginLeft: '4px',
                cursor: 'pointer',
              }}
            >
              Login
            </a>
          </span>
        )}
      </div>
    </SignUpContainer>
  );
};
